import React, { Component } from "react";
import { apiURL } from "../Services/baseURL"
import "./HidonPage.scss"
import { DomRadioField } from "../Services/FormDOM";
import { usingQuizzesAPI } from "../Services/fetchService";
import { returnValue } from "../Services/Validation";
import Loading from "../Services/Loading/Loading";
import { push } from "../Services/Analytics";


export default class HidonPage extends Component {
    constructor(props) {
        super();
        this.state = {
            time: 1,
            current: 0,
            Proxy: -1,
            isBusy: false,
            isLoading: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.saveAndValidate = this.saveAndValidate.bind(this);
    }
    componentDidMount() {
        this.setState({
            time: new Date().getTime()
        })
    }
    getQuestions() {
        return this.props.QuizQuestions.map((item, index) =>
            <QuizzQuestion key={index} index={index}
                limit={this.props.QuizQuestions.length}
                handleInputChange={this.handleInputChange}
                current={this.state.current}
                {...item}
            />
        )
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            },
            Proxy: (this.state.current != this.state.Proxy ? Math.round(this.state.Proxy + 1) : this.state.Proxy)
        });
    }
    navigate(_num) {
        var num = (_num > this.props.QuizQuestionslength - 1 ? this.props.QuizQuestionslength - 1 : _num);
        num = (_num < 0 ? 0 : _num);
        this.setState({
            current: num
        })
    }
    saveAndValidate() {
        if (this.state.isBusy) return;
        this.setState({
            isBusy: true
        });

        const state = this.state,
            Parent = this.props.state,
            Answers = [];

        let counter = 0;

        for (var i = 0; i < this.props.QuizQuestionslength; i++) {
            if (state[`question${i}`]) {
                Answers.push(parseInt(state[`question${i}`].value))
                counter++
            }
        }
        if (counter < this.props.QuizQuestionslength) {
            alert("לא ניתן לשלוח את החידון מבלי לענות על כל השאלות");
            return;
        }

        this.setState({
            isLoading: true
        }, () => {
            push("Chicago", "form_sent");
            usingQuizzesAPI.saveResults({
                FullName: returnValue(Parent.FullName),
                Age: returnValue(Parent.Age),
                Gender: returnValue(Parent.Gender),
                Email: returnValue(Parent.Email),
                PhoneNumber: returnValue(Parent.PhoneNumber),
                Answers: Answers,
                TimeTaken: Math.round((new Date().getTime() - this.state.time))
            }, (data) => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                }, () => this.props.setPage("end"));
            })
        })
    }
    render() {
        return (
            <section className="section section-hidon">
                <div className="padding">
                    <div className="container">
                        <div className="questions-container">
                            {this.getQuestions()}
                            <Loading showLoading={this.state.isLoading} />
                        </div>
                        <div className="nav">
                            <div className="arrows">
                                <div onClick={(_num) => { this.navigate(Math.round(this.state.current - 1)) }} className="back" style={{ display: (this.state.current == 0 ? "none" : "inline-block") }}></div>
                                <div className="num"> {Math.round(this.props.QuizQuestionslength)} / <span>{Math.round(this.state.current + 1)}</span> </div>
                                <div onClick={(_num) => { this.navigate(Math.round(this.state.current + 1)) }} className="next" style={{ display: (this.state.current == this.props.QuizQuestionslength - 1 ? "none" : (this.state.Proxy >= this.state.current ? "inline-block" : "none")) }}></div>
                            </div>
                            <div className="send" style={{ display: (this.state.current == this.props.QuizQuestionslength - 1 ? "block" : "none") }}>
                                <div className="button" onClick={this.saveAndValidate}></div>
                            </div>
                            <div className="send desktop">
                                <div className="button" onClick={this.saveAndValidate}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const QuizzQuestion = (props) => {
    return (
        <div className={`quizz${(props.current == props.index ? " active" : (props.current == null ? (props.index == 0 ? " active" : "") : ""))}${(props.index == props.limit ? " last" : "")}`}>
            <div className="quizz-container">
                <div className="headline">
                    <div className="num">{`${Math.round(props.index + 1)}. `}</div>
                    <div className="head">
                        <h4>{props.Question}</h4>
                    </div>
                </div>
                <div className="questions">
                    {
                        props.Answers.map((item, index) =>
                            <DomRadioField key={index} index={index}
                                value={item.ID}
                                label={item.Answer}
                                type="radio"
                                name={`question${props.index}`}
                                id={`question${props.index}_${index}`}
                                onChange={props.handleInputChange} />
                        )
                    }
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Components/Body/HidonPage.jsx